import { render } from "./SortBox.vue?vue&type=template&id=03e6a0c5&scoped=true"
import script from "./SortBox.vue?vue&type=script&lang=js"
export * from "./SortBox.vue?vue&type=script&lang=js"

import "./SortBox.vue?vue&type=style&index=0&id=03e6a0c5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03e6a0c5"

export default script